import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

export const useIsLoggingIn = () => {
  const { authMachineRef } = useEssentialMachines();

  const isLoggingIn = useSelector(authMachineRef, (state) => {
    const { matches } = state;

    const isFetchingSession = matches('idle');
    const isFetchingCustomer = !matches('session.loggedIn') && matches('fetching.customer');

    return isFetchingSession || isFetchingCustomer;
  });

  return Boolean(isLoggingIn);
};

export const useIsLoggedIn = () => {
  const { authMachineRef } = useEssentialMachines();

  const isLoggedIn = useSelector(authMachineRef, (state) => {
    const { matches } = state;

    return matches('session.loggedIn');
  });

  return Boolean(isLoggedIn);
};

export const useIsFirstAuthAttempt = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.isFirstAuthAttempt);
};
